module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-style"
  }, [_c('div', {
    staticClass: "oddStyle"
  }, [_vm._v(_vm._s(this.label))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "checkBlock"
    }
  }, _vm._l((_vm.optionVal), function(op, index) {
    return _c('div', {
      staticClass: "block pointer",
      class: {
        checkColor: op.checked
      },
      on: {
        "click": function($event) {
          _vm.sendData(op)
        }
      }
    }, [_vm._v(_vm._s(op.text))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1200abc0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/checkBlock.vue
// module id = 950
// module chunks = 2